// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","268":"component---src-components-templates-post-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"919945a6117ee2089a5e","268":"a340fa93d85f44eb9858","453":"0736236987176fb8bb9d"}[chunkId] + ".js";
};